// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__EPs3I","resizer_container":"Home_resizer_container__MzPz2","resizeHandle":"Home_resizeHandle__26NIP","active":"Home_active__1dogI"};